/**课程学习模块 */
import request from '../request/http';
/**获取学习进度 */
export function GetStudyProgress(data){
    return request({
        url: '/sp/study/getStudyProgress',
        method: 'post',
        data
    })
}
/**更新学习进度 */
export function UpdateStudyProgress(data){
    return request({
        url: '/sp/study/updateStudyProgress',
        method: 'post',
        data
    })
}
/**学习课程 */
export function StudyCourse(data){
    return request({
        url: '/sp/study/studyCourse',
        method: 'post',
        data
    })
}
/**新增学习记录 */
export function AddStudyRecord(data){
    return request({
        url: '/sp/study/addStudyRecord',
        method: 'post',
        data
    })
}